import ClientListItem from "./ClientListItem"

export default  ClientListItem;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientList/ClientListItem/index.js